import { Link } from "react-router-dom";
import { Wordmark } from "./Nav";

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-6">
          <div className="col-span-2">
            <Wordmark light />
            <p className="mt-4 text-ivory/50 text-sm max-w-xs font-light leading-relaxed">
              Premium Fashion. Give It Another Life. Discover premium brands, curated fashion and a smarter way to give your wardrobe new value.
            </p>
            <p className="mt-6 text-[11px] tracking-[0.2em] uppercase text-gold/80">Only resale-standard items become JIGEL products</p>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.25em] uppercase text-ivory/40 mb-5">Shop</p>
            <div className="flex flex-col gap-3 text-sm text-ivory/70">
              <Link to="/men" data-testid="footer-men" className="hover:text-ivory transition-colors">Men</Link>
              <Link to="/women" data-testid="footer-women" className="hover:text-ivory transition-colors">Women</Link>
              <Link to="/kids" data-testid="footer-kids" className="hover:text-ivory transition-colors">Kids</Link>
              <Link to="/pre-loved" data-testid="footer-preloved" className="hover:text-ivory transition-colors">Pre-Loved</Link>
              <Link to="/new-arrivals" data-testid="footer-new" className="hover:text-ivory transition-colors">New Arrivals</Link>
              <Link to="/sale" data-testid="footer-sale" className="hover:text-ivory transition-colors">Sale</Link>
            </div>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.25em] uppercase text-ivory/40 mb-5">Sell</p>
            <div className="flex flex-col gap-3 text-sm text-ivory/70">
              <Link to="/sell" data-testid="footer-tradein" className="hover:text-ivory transition-colors">Sell Your Clothes</Link>
              <Link to="/cloth-cash" data-testid="footer-clothcash" className="hover:text-ivory transition-colors">Cloth Cash</Link>
              <Link to="/account?tab=submissions" data-testid="footer-mytradeins" className="hover:text-ivory transition-colors">My Submissions</Link>
              <Link to="/about" data-testid="footer-about" className="hover:text-ivory transition-colors">About Jigel</Link>
              <Link to="/grade-guide" data-testid="footer-grade-guide" className="hover:text-ivory transition-colors">How We Grade</Link>
            </div>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.25em] uppercase text-ivory/40 mb-5">Jigel</p>
            <div className="flex flex-col gap-3 text-sm text-ivory/70">
              <Link to="/brands" data-testid="footer-brands" className="hover:text-ivory transition-colors">Brands</Link>
              <Link to="/account" data-testid="footer-account" className="hover:text-ivory transition-colors">My Account</Link>
              <Link to="/cart" data-testid="footer-cart" className="hover:text-ivory transition-colors">Cart</Link>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col md:flex-row justify-between gap-4 text-[11px] tracking-[0.15em] uppercase text-ivory/35">
          <p>© {new Date().getFullYear()} Jigel. All rights reserved.</p>
          <p>Brand names shown are catalog categories. No authorized-retailer claim is made or implied.</p>
        </div>
      </div>
    </footer>
  );
}
